webpackJsonp([2],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.renderEmployeeDialog = undefined;
	
	var _extends2 = __webpack_require__(54);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(249);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	__webpack_require__(120);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Container = __webpack_require__(670);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _fluxible = __webpack_require__(455);
	
	var _fluxible2 = _interopRequireDefault(_fluxible);
	
	var _fluxibleAddonsReact = __webpack_require__(61);
	
	var _LoginStore = __webpack_require__(375);
	
	var _LoginStore2 = _interopRequireDefault(_LoginStore);
	
	var _ContactMeStore = __webpack_require__(241);
	
	var _ContactMeStore2 = _interopRequireDefault(_ContactMeStore);
	
	var _MessageStore = __webpack_require__(663);
	
	var _MessageStore2 = _interopRequireDefault(_MessageStore);
	
	var _MessageDefinitions = __webpack_require__(145);
	
	var _MessageDefinitions2 = _interopRequireDefault(_MessageDefinitions);
	
	var _Messages = __webpack_require__(119);
	
	var _Messages2 = _interopRequireDefault(_Messages);
	
	var _batchedUpdatePlugin = __webpack_require__(306);
	
	var _batchedUpdatePlugin2 = _interopRequireDefault(_batchedUpdatePlugin);
	
	var _CommonActions = __webpack_require__(370);
	
	var _CommonActions2 = _interopRequireDefault(_CommonActions);
	
	var _Actions = __webpack_require__(243);
	
	var _Actions2 = _interopRequireDefault(_Actions);
	
	var _SearchActionCreators = __webpack_require__(122);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var app = new _fluxible2.default({ component: _Container2.default }); /**
	                                                                       * (c) 2015 Ignite Sales, Inc.
	                                                                       * User: aholmes
	                                                                       * Date: 4/13/2016
	                                                                       * Time: 11:37 AM
	                                                                       */
	
	app.plug((0, _batchedUpdatePlugin2.default)());
	app.registerStore(_LoginStore2.default);
	app.registerStore(_MessageStore2.default);
	
	function render(nodeId) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      selectedEmployeeId = _ref.selectedEmployeeId,
	      thirdPartyId = _ref.thirdPartyId,
	      defaultFields = _ref.defaultFields;
	
	  var mountNode = document.getElementById(nodeId);
	  app.rehydrate({}, function (err, context) {
	    function doRender() {
	      _reactDom2.default.render(_react2.default.createElement(_fluxibleAddonsReact.FluxibleComponent, {
	        context: context.getComponentContext()
	      }, _react2.default.createElement(_Container2.default, null)), mountNode);
	    }
	    context.executeAction(_SearchActionCreators.loadEmployeeById, { selectedEmployeeId: selectedEmployeeId, thirdPartyId: thirdPartyId }).then(function (employee) {
	      context.getActionContext().dispatch(_CommonActions2.default.MESSAGES_LOADED, _Messages2.default.get(_MessageDefinitions2.default));
	      if (employee && (0, _keys2.default)(employee).length > 0) {
	        context.getActionContext().dispatch(_Actions2.default.ENABLE_EDIT, false);
	        doRender();
	      } else if (defaultFields) {
	        context.executeAction(_SearchActionCreators.editEmployee, (0, _extends3.default)({}, defaultFields)).then(function () {
	          doRender();
	        });
	      } else {
	        doRender();
	      }
	    });
	  });
	}
	
	function renderEmployeeDialog(employeeLoginId, params) {
	  render(employeeLoginId, params || {});
	}
	
	if (window.ignite) {
	  window.ignite.renderEmployeeDialog = renderEmployeeDialog;
	}
	
	exports.renderEmployeeDialog = renderEmployeeDialog;

/***/ },

/***/ 122:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.login = exports.backToSearchClicked = exports.employeeCancelClicked = exports.selectEmployee = exports.saveEmployeeProfile = exports.employeeValidationError = exports.editEmployee = exports.newEmployee = exports.loadBranches = exports.searchEmployeeConflicts = exports.loadEmployees = exports.loadEmployeeById = undefined;
	
	var _regenerator = __webpack_require__(184);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(182);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _promise = __webpack_require__(123);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	/**
	 * Loads an employee by either an ignite employee id or a 3rd party (client's) identifier.
	 *
	 * First tries to look by ignite id, then, if not found, search by client's id.
	 * If an employee is found, it will be selected.
	 *
	 * @param context
	 * @param selectedEmployeeId
	 * @param thirdPartyId
	 * @returns {Promise.<*>}
	 */
	var loadEmployeeById = exports.loadEmployeeById = function () {
	  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(context, _ref2) {
	    var selectedEmployeeId = _ref2.selectedEmployeeId,
	        thirdPartyId = _ref2.thirdPartyId;
	    var employeeLoginService, employee;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            if (!(selectedEmployeeId || thirdPartyId)) {
	              _context.next = 18;
	              break;
	            }
	
	            console.log('Logging in with selected employee', { selectedEmployeeId: selectedEmployeeId, thirdPartyId: thirdPartyId });
	            _context.next = 4;
	            return loginService();
	
	          case 4:
	            employeeLoginService = _context.sent;
	            _context.next = 7;
	            return employeeLoginService.get(selectedEmployeeId || thirdPartyId);
	
	          case 7:
	            employee = _context.sent;
	
	            if (!employee) {
	              _context.next = 15;
	              break;
	            }
	
	            context.dispatch(_Actions2.default.EMPLOYEES_LOADED, [employee]);
	            _context.next = 12;
	            return context.executeAction(selectEmployee, employee);
	
	          case 12:
	            return _context.abrupt('return', employee);
	
	          case 15:
	            console.log("Looking for employee, but found none");
	
	          case 16:
	            _context.next = 19;
	            break;
	
	          case 18:
	            console.log('No employee selected, falling back to normal login dialog.');
	
	          case 19:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function loadEmployeeById(_x, _x2) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var loadEmployees = exports.loadEmployees = function () {
	  var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(context, _ref4) {
	    var _ref4$searchValue = _ref4.searchValue,
	        searchValue = _ref4$searchValue === undefined ? '' : _ref4$searchValue;
	    var employeeLoginService, result;
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            context.dispatch(_Actions2.default.EMPLOYEE_SEARCH_STARTED);
	            context.dispatch(_Actions2.default.EMPLOYEE_SEARCH_VALUE_CHANGED, searchValue);
	
	            _context2.next = 4;
	            return loginService();
	
	          case 4:
	            employeeLoginService = _context2.sent;
	            _context2.next = 7;
	            return employeeLoginService.search(searchValue);
	
	          case 7:
	            result = _context2.sent;
	
	            context.dispatch(_Actions2.default.EMPLOYEES_LOADED, result);
	
	            return _context2.abrupt('return', result);
	
	          case 10:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function loadEmployees(_x3, _x4) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	var searchEmployeeConflicts = exports.searchEmployeeConflicts = function () {
	  var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(context, _ref6) {
	    var _ref6$searchByEmail = _ref6.searchByEmail,
	        searchByEmail = _ref6$searchByEmail === undefined ? false : _ref6$searchByEmail,
	        _ref6$searchById = _ref6.searchById,
	        searchById = _ref6$searchById === undefined ? false : _ref6$searchById;
	    var LoginStore, employeeLoginService, currentEmployee, result, byEmail, byId;
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            context.dispatch(_Actions2.default.EMPLOYEE_SEARCH_STARTED);
	            LoginStore = context.getStore('LoginStore');
	            _context3.next = 4;
	            return loginService();
	
	          case 4:
	            employeeLoginService = _context3.sent;
	            currentEmployee = LoginStore.getSelectedEmployee() || {};
	            result = {
	              email: false,
	              id: false
	            };
	
	            if (!searchByEmail) {
	              _context3.next = 12;
	              break;
	            }
	
	            _context3.next = 10;
	            return employeeLoginService.searchByEmail(searchByEmail);
	
	          case 10:
	            byEmail = _context3.sent;
	
	            if (byEmail && byEmail.id && byEmail.id !== currentEmployee.id) {
	              result.email = byEmail;
	            }
	
	          case 12:
	            if (!searchById) {
	              _context3.next = 17;
	              break;
	            }
	
	            _context3.next = 15;
	            return employeeLoginService.searchByThirdPartyId(searchById);
	
	          case 15:
	            byId = _context3.sent;
	
	            if (byId && byId.id && byId.id !== currentEmployee.id) {
	              result.id = byId;
	            }
	
	          case 17:
	            context.dispatch(_Actions2.default.EMPLOYEES_CONFLICTS_LOADED, result);
	
	            return _context3.abrupt('return', result);
	
	          case 19:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function searchEmployeeConflicts(_x5, _x6) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	
	var loadBranches = exports.loadBranches = function () {
	  var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(context, _ref8) {
	    var _ref8$searchValue = _ref8.searchValue,
	        searchValue = _ref8$searchValue === undefined ? '' : _ref8$searchValue;
	    var employeeLoginService, result;
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            context.dispatch(_Actions2.default.BRANCH_SEARCH_STARTED);
	
	            if (!(searchValue.length >= 3)) {
	              _context4.next = 13;
	              break;
	            }
	
	            console.log('searching for branches', searchValue);
	            _context4.next = 5;
	            return loginService();
	
	          case 5:
	            employeeLoginService = _context4.sent;
	            _context4.next = 8;
	            return employeeLoginService.findBranches(searchValue);
	
	          case 8:
	            result = _context4.sent;
	
	
	            context.dispatch(_Actions2.default.BRANCHES_LOADED, result);
	            return _context4.abrupt('return', result);
	
	          case 13:
	            context.dispatch(_Actions2.default.BRANCHES_LOADED, []);
	            return _context4.abrupt('return', []);
	
	          case 15:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function loadBranches(_x7, _x8) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	var newEmployee = exports.newEmployee = function () {
	  var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(context) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            context.dispatch(_Actions2.default.NEW_EMPLOYEE_SELECTED);
	
	          case 1:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, this);
	  }));
	
	  return function newEmployee(_x9) {
	    return _ref9.apply(this, arguments);
	  };
	}();
	
	var editEmployee = exports.editEmployee = function () {
	  var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(context, employee) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            context.dispatch(_Actions2.default.EDIT_EMPLOYEE_SELECTED, employee);
	
	          case 1:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, this);
	  }));
	
	  return function editEmployee(_x10, _x11) {
	    return _ref10.apply(this, arguments);
	  };
	}();
	
	var employeeValidationError = exports.employeeValidationError = function () {
	  var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(context, errors) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            context.dispatch(_Actions2.default.EMPLOYEE_UPDATE_ERROR, errors.map(function (error) {
	              return {
	                key: error.path,
	                errors: [error.message]
	              };
	            }));
	
	          case 1:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, this);
	  }));
	
	  return function employeeValidationError(_x12, _x13) {
	    return _ref11.apply(this, arguments);
	  };
	}();
	
	var saveEmployeeProfile = exports.saveEmployeeProfile = function () {
	  var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(context, _ref13) {
	    var employee = _ref13.employee;
	    var employeeLoginService, result;
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            context.dispatch(_Actions2.default.EMPLOYEE_UPDATE_STARTED);
	
	            _context8.prev = 1;
	            _context8.next = 4;
	            return loginService();
	
	          case 4:
	            employeeLoginService = _context8.sent;
	            _context8.next = 7;
	            return employeeLoginService.save(employee);
	
	          case 7:
	            result = _context8.sent;
	
	
	            if (result.status === 'success') {
	              context.dispatch(_Actions2.default.EMPLOYEE_UPDATE_SUCCESSFUL, result.employee);
	            } else {
	              if (result.errors) {
	                context.dispatch(_Actions2.default.EMPLOYEE_UPDATE_ERROR, result.errors);
	              }
	              context.dispatch(_Actions2.default.EMPLOYEE_UPDATE_FAILED, result);
	            }
	
	            _context8.next = 14;
	            break;
	
	          case 11:
	            _context8.prev = 11;
	            _context8.t0 = _context8['catch'](1);
	
	            context.dispatch(_Actions2.default.EMPLOYEE_UPDATE_FAILED);
	
	          case 14:
	          case 'end':
	            return _context8.stop();
	        }
	      }
	    }, _callee8, this, [[1, 11]]);
	  }));
	
	  return function saveEmployeeProfile(_x14, _x15) {
	    return _ref12.apply(this, arguments);
	  };
	}();
	
	var selectEmployee = exports.selectEmployee = function () {
	  var _ref14 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(context, employee) {
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            console.log('Employee clicked', employee);
	
	            if (!(!employee.branches || employee.branches.length === 0)) {
	              _context9.next = 6;
	              break;
	            }
	
	            _context9.next = 4;
	            return context.executeAction(editEmployee, employee);
	
	          case 4:
	            _context9.next = 7;
	            break;
	
	          case 6:
	            context.dispatch(_Actions2.default.EMPLOYEE_SELECTED, employee);
	
	          case 7:
	          case 'end':
	            return _context9.stop();
	        }
	      }
	    }, _callee9, this);
	  }));
	
	  return function selectEmployee(_x16, _x17) {
	    return _ref14.apply(this, arguments);
	  };
	}();
	
	var employeeCancelClicked = exports.employeeCancelClicked = function () {
	  var _ref15 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10(context) {
	    return _regenerator2.default.wrap(function _callee10$(_context10) {
	      while (1) {
	        switch (_context10.prev = _context10.next) {
	          case 0:
	            context.dispatch(_Actions2.default.EMPLOYEE_UPDATE_CANCELED);
	
	          case 1:
	          case 'end':
	            return _context10.stop();
	        }
	      }
	    }, _callee10, this);
	  }));
	
	  return function employeeCancelClicked(_x18) {
	    return _ref15.apply(this, arguments);
	  };
	}();
	
	var backToSearchClicked = exports.backToSearchClicked = function () {
	  var _ref16 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11(context) {
	    var LoginStore;
	    return _regenerator2.default.wrap(function _callee11$(_context11) {
	      while (1) {
	        switch (_context11.prev = _context11.next) {
	          case 0:
	            context.dispatch(_Actions2.default.EMPLOYEE_DESELECTED);
	            LoginStore = context.getStore('LoginStore');
	
	            context.executeAction(loadEmployees, {
	              searchValue: LoginStore.getEmployeeSearchValue()
	            });
	
	          case 3:
	          case 'end':
	            return _context11.stop();
	        }
	      }
	    }, _callee11, this);
	  }));
	
	  return function backToSearchClicked(_x19) {
	    return _ref16.apply(this, arguments);
	  };
	}();
	
	var login = exports.login = function () {
	  var _ref17 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12(context, _ref18) {
	    var employee = _ref18.employee,
	        branch = _ref18.branch;
	    var employeeLoginService, result, loggedInEmployee, loggedInBranch;
	    return _regenerator2.default.wrap(function _callee12$(_context12) {
	      while (1) {
	        switch (_context12.prev = _context12.next) {
	          case 0:
	            context.dispatch(_Actions2.default.EMPLOYEE_LOGIN_STARTED);
	            _context12.next = 3;
	            return loginService();
	
	          case 3:
	            employeeLoginService = _context12.sent;
	            _context12.next = 6;
	            return employeeLoginService.login({
	              employee: employee,
	              branch: branch
	            });
	
	          case 6:
	            result = _context12.sent;
	
	
	            if (result.status === 'success') {
	              loggedInEmployee = result.employee, loggedInBranch = result.branch;
	
	              context.dispatch(_Actions2.default.EMPLOYEE_LOGGED_IN);
	              console.log('Employee logged in', {
	                employee: loggedInEmployee,
	                branch: loggedInBranch
	              });
	
	              if (window.ignite.employeeLoggedIn) {
	                window.ignite.employeeLoggedIn({
	                  employee: loggedInEmployee,
	                  branch: loggedInBranch
	                });
	              }
	            }
	
	          case 8:
	          case 'end':
	            return _context12.stop();
	        }
	      }
	    }, _callee12, this);
	  }));
	
	  return function login(_x20, _x21) {
	    return _ref17.apply(this, arguments);
	  };
	}();
	
	var _Actions = __webpack_require__(243);
	
	var _Actions2 = _interopRequireDefault(_Actions);
	
	var _LoginStore = __webpack_require__(375);
	
	var _LoginStore2 = _interopRequireDefault(_LoginStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by bholmes on 4/19/2016.
	 */
	function loginService() {
	  return new _promise2.default(function (resolve, reject) {
	    function serviceCheck() {
	      if (window.ignite.employeeLoginService) {
	        resolve(window.ignite.employeeLoginService);
	      } else {
	        console.log('employeeLoginService not available.  Trying again.');
	        window.setTimeout(serviceCheck, 100);
	      }
	    }
	
	    window.setTimeout(serviceCheck, 0);
	  });
	}

/***/ },

/***/ 145:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * (c) 2015 Ignite Sales, Inc.
	 * User: aholmes
	 * Date: 6/8/2016
	 * Time: 9:58 AM
	 */
	exports.default = {
	  edit: {
	    id: 'employeeLogin.edit',
	    description: 'Message for an edit button',
	    defaultMessage: 'Edit'
	  },
	  login: {
	    id: 'employeeLogin.login',
	    description: 'Message for an login button',
	    defaultMessage: 'Login'
	  },
	  save: {
	    id: 'employeeLogin.save',
	    description: 'Message for a save button',
	    defaultMessage: 'Save'
	  },
	  cancel: {
	    id: 'employeeLogin.cancel',
	    description: 'Message for a cancel button',
	    defaultMessage: 'Cancel'
	  },
	  firstName: {
	    id: 'employeeLogin.firstName',
	    description: 'Descriptive text for first name field',
	    defaultMessage: 'First Name'
	  },
	  firstNamePlaceholder: {
	    id: 'employeeLogin.firstName.placeholder',
	    description: 'Descriptive text for first name placeholder',
	    defaultMessage: 'First Name'
	  },
	  lastName: {
	    id: 'employeeLogin.lastName',
	    description: 'Descriptive text for last name field',
	    defaultMessage: 'Last Name'
	  },
	  lastNamePlaceholder: {
	    id: 'employeeLogin.lastName.placeholder',
	    description: 'Descriptive text for last name placeholder',
	    defaultMessage: 'Last Name'
	  },
	  employeeId: {
	    id: 'employeeLogin.employeeId',
	    description: 'Descriptive text for employeeId field',
	    defaultMessage: 'Employee ID'
	  },
	  employeeIdPlaceholder: {
	    id: 'employeeLogin.employeeId.placeholder',
	    description: 'Descriptive text for employeeId placeholder',
	    defaultMessage: 'Employee ID'
	  },
	  email: {
	    id: 'employeeLogin.email',
	    description: 'Descriptive text for email field',
	    defaultMessage: 'Email'
	  },
	  emailPlaceholder: {
	    id: 'employeeLogin.email.placeholder',
	    description: 'Descriptive text for email placeholder',
	    defaultMessage: 'user@email.com'
	  },
	  phone: {
	    id: 'employeeLogin.phone',
	    description: 'Descriptive text for phone field',
	    defaultMessage: 'Phone Number'
	  },
	  phonePlaceholder: {
	    id: 'employeeLogin.phone.placeholder',
	    description: 'Placeholder for phone input',
	    defaultMessage: '(555) 123-4567'
	  },
	  branchesAssociated: {
	    id: 'employeeLogin.branches.associated',
	    description: 'A message to display indicating the user is associated with the given branches',
	    defaultMessage: 'Associated Branches'
	  },
	  branchesSelect: {
	    id: 'employeeLogin.branches.select',
	    description: 'A message to display when a user must select a branch prior to logging in',
	    defaultMessage: 'Please select a branch and click login'
	  },
	  branchesSearch: {
	    id: 'employeeLogin.branches.search',
	    description: 'Label text for branch search box',
	    defaultMessage: 'Branch search'
	  },
	  branchesSearchPlaceholder: {
	    id: 'employeeLogin.branches.search.placeholder',
	    description: 'Placeholder text for branch search box',
	    defaultMessage: 'Start typing to search...'
	  },
	  nmlsId: {
	    id: 'employeeLogin.nmlsId',
	    description: 'Descriptive text for nmlsId field',
	    defaultMessage: 'NMLS #'
	  },
	  nmlsIdPlaceholder: {
	    id: 'employeeLogin.nmlsId.placeholder',
	    description: 'Descriptive text for nmlsId placeholder',
	    defaultMessage: 'NMLS #'
	  },
	  nmlsIdError: {
	    id: 'employeeLogin.errors.nmlsId',
	    description: 'Error message for invalid nmlsId',
	    defaultMessage: 'Please enter a valid NMLS #'
	  },
	  firstNameError: {
	    id: 'employeeLogin.errors.firstName',
	    description: 'Error message for missing First Name',
	    defaultMessage: 'First Name is required.'
	  },
	  lastNameError: {
	    id: 'employeeLogin.errors.lastName',
	    description: 'Error message for missing Last Name',
	    defaultMessage: 'Last Name is required.'
	  },
	  employeeIdError: {
	    id: 'employeeLogin.errors.employeeId',
	    description: 'Error message for employeeId',
	    defaultMessage: 'Employee ID is required.'
	  },
	  emailError: {
	    id: 'employeeLogin.errors.email',
	    description: 'Error message for missing email address',
	    defaultMessage: 'A valid email address is required.'
	  },
	  phoneError: {
	    id: 'employeeLogin.errors.phone',
	    description: 'Error message for missing phone number',
	    defaultMessage: 'A valid 10-digit US phone number is required.'
	  },
	  employeeBranchesError: {
	    id: 'employeeLogin.errors.employeeBranches',
	    description: 'Error message when a user is not associated with any branches',
	    defaultMessage: 'Please use the branch search box above to add a branch to your profile.'
	  },
	  search: {
	    id: 'employeeLogin.search',
	    description: 'Search',
	    defaultMessage: 'Search'
	  },
	  searchText: {
	    id: 'employeeLogin.search.description',
	    description: 'Helper text that displays on the login dialog.',
	    defaultMessage: 'Enter your employee id, name, email address, or phone number to search'
	  },
	  findProfile: {
	    id: 'employeeLogin.search.label',
	    description: 'The label for the employee login search box',
	    defaultMessage: 'Find an employee profile'
	  },
	  findProfilePlaceholder: {
	    id: 'employeeLogin.search.placeholder',
	    description: 'The label for the employee login search box',
	    defaultMessage: 'employee id/name/email/phone'
	  },
	  newProfile: {
	    id: 'employeeLogin.newProfile.text',
	    description: 'The text to display for the button a user will click to create a new profile.',
	    defaultMessage: 'New Profile'
	  },
	  noProfiles: {
	    id: 'employeeLogin.search.empty',
	    description: 'A message to display when there are no profiles found.',
	    defaultMessage: 'No results found.  Search again or click "New Profile" below to create a profile.'
	  },
	  profileConflicts: {
	    id: 'employeeLogin.search.conflicts',
	    description: 'A message to display when there are ID or email conflicts during new profile creation.',
	    defaultMessage: 'The following profile(s) were found based on the information you entered.'
	  },
	  emailConflicts: {
	    id: 'employeeLogin.search.conflicts.email',
	    description: 'A message to display when there are email address conflicts during new profile creation.',
	    defaultMessage: 'Another profile already exists with the same email address.  Please scroll down to choose from one of the existing profiles, or enter a unique value'
	  },
	  employeeIdConflicts: {
	    id: 'employeeLogin.search.conflicts.employeeId',
	    description: 'A message to display when there are ID conflicts during new profile creation.',
	    defaultMessage: 'Another profile already exists with the same Employee ID.  Please scroll down to choose from one of the existing profiles, or enter a unique value'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ 242:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Shapes = __webpack_require__(81);
	
	var _libphonenumber = __webpack_require__(212);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var phoneUtil = _libphonenumber.PhoneNumberUtil.getInstance();
	
	var EmployeeResult = function EmployeeResult(props) {
	  var _props$employee = props.employee,
	      employeeId = _props$employee.employeeId,
	      firstName = _props$employee.firstName,
	      lastName = _props$employee.lastName,
	      email = _props$employee.email,
	      phone = _props$employee.phone,
	      branches = _props$employee.branches,
	      onClick = props.onClick;
	
	
	  var phoneNumber = phoneUtil.format(phoneUtil.parse(phone, 'US'), _libphonenumber.PhoneNumberFormat.NATIONAL);
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'employee-login-result', onClick: onClick },
	    _react2.default.createElement(
	      'div',
	      { className: 'name' },
	      _react2.default.createElement(
	        'span',
	        { className: 'firstName' },
	        firstName
	      ),
	      ' ',
	      _react2.default.createElement(
	        'span',
	        { className: 'lastName' },
	        lastName
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'customerId' },
	      employeeId
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'email' },
	      email
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'phone' },
	      phoneNumber
	    )
	  );
	};
	
	EmployeeResult.propTypes = {
	  employee: _Shapes.EmployeeShape,
	  onClick: _propTypes2.default.func
	};
	
	exports.default = EmployeeResult;
	module.exports = exports['default'];

/***/ },

/***/ 243:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keymirror = __webpack_require__(310);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Actions = (0, _keymirror2.default)({
	  BRANCHES_LOADED: null,
	  BRANCH_SEARCH_STARTED: null,
	  BRANCH_SEARCH_FAILED: null,
	  EMPLOYEES_LOADED: null,
	  EMPLOYEES_CONFLICTS_LOADED: null,
	  EMPLOYEE_SEARCH_VALUE_CHANGED: null,
	  BRANCH_SEARCH_VALUE_CHANGED: null,
	  NEW_EMPLOYEE_SELECTED: null,
	  EDIT_EMPLOYEE_SELECTED: null,
	  EMPLOYEE_SEARCH_STARTED: null,
	  EMPLOYEE_SEARCH_FAILED: null,
	  EMPLOYEE_UPDATE_STARTED: null,
	  EMPLOYEE_UPDATE_SUCCESSFUL: null,
	  EMPLOYEE_UPDATE_CANCELED: null,
	  EMPLOYEE_UPDATE_ERROR: null,
	  EMPLOYEE_UPDATE_FAILED: null,
	  EMPLOYEE_SELECTED: null,
	  EMPLOYEE_DESELECTED: null,
	  EMPLOYEE_LOGGED_IN: null,
	  EMPLOYEE_LOGIN_STARTED: null,
	  ENABLE_EDIT: null
	}); /**
	     * (c) 2015 Ignite Sales, Inc.
	     * User: aholmes
	     * Date: 4/13/2016
	     * Time: 11:49 AM
	     */
	exports.default = Actions;
	module.exports = exports['default'];

/***/ },

/***/ 370:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keymirror = __webpack_require__(310);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommonActions = (0, _keymirror2.default)({
	  MESSAGES_LOADED: null,
	  LOCALE_CHANGED: null
	}); /**
	     * (c) 2015 Ignite Sales, Inc.
	     * User: aholmes
	     * Date: 6/23/2016
	     * Time: 1:10 PM
	     */
	exports.default = CommonActions;
	module.exports = exports['default'];

/***/ },

/***/ 374:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Shapes = __webpack_require__(81);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BranchResult = function BranchResult(props) {
	  var name = props.branch.name,
	      _props$className = props.className,
	      className = _props$className === undefined ? '' : _props$className,
	      onClick = props.onClick,
	      children = props.children;
	
	
	  var classes = className + ' branch-login-result';
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes, onClick: onClick },
	    name,
	    ' ',
	    children
	  );
	};
	
	BranchResult.propTypes = {
	  branch: _Shapes.BranchShape.isRequired,
	  onClick: _propTypes2.default.func,
	  className: _propTypes2.default.string
	};
	
	exports.default = BranchResult;
	module.exports = exports['default'];

/***/ },

/***/ 375:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(250);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(27);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(29);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(28);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp, _class$handlers; /**
	                                     * Created by bholmes on 4/14/2016.
	                                     */
	
	var _fluxibleImmutableUtils = __webpack_require__(307);
	
	var _Actions = __webpack_require__(243);
	
	var _Actions2 = _interopRequireDefault(_Actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoginStore = (_temp = _class = function (_ImmutableStore) {
	  (0, _inherits3.default)(LoginStore, _ImmutableStore);
	
	  function LoginStore(dispatcher) {
	    (0, _classCallCheck3.default)(this, LoginStore);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (LoginStore.__proto__ || (0, _getPrototypeOf2.default)(LoginStore)).call(this, dispatcher));
	
	    _this.setState({
	      employees: [],
	      employeeConflicts: [],
	      branches: [],
	      selectedScreen: 'search',
	      employeeSearchValue: '',
	      employeeErrors: [],
	      processing: false,
	      allowEdit: true
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(LoginStore, [{
	    key: 'handleEnableEdit',
	    value: function handleEnableEdit(allowEdit) {
	      this.mergeState({
	        allowEdit: allowEdit
	      });
	    }
	  }, {
	    key: 'processingStarted',
	    value: function processingStarted() {
	      this.mergeState({
	        processing: true
	      });
	    }
	  }, {
	    key: 'processingCompleted',
	    value: function processingCompleted() {
	      this.mergeState({
	        processing: false
	      });
	    }
	  }, {
	    key: 'handleEmployeesLoaded',
	    value: function handleEmployeesLoaded() {
	      var employees = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      this.mergeState({
	        employees: employees,
	        processing: false
	      });
	    }
	  }, {
	    key: 'handleEmployeeConflictsLoaded',
	    value: function handleEmployeeConflictsLoaded(conflicts) {
	      var email = conflicts.email,
	          id = conflicts.id;
	
	      var employeeConflicts = [];
	
	      if (email) {
	        employeeConflicts.push(email);
	      }
	      if (id) {
	        employeeConflicts.push(id);
	      }
	
	      this.mergeState({
	        employeeConflicts: employeeConflicts,
	        processing: false
	      });
	    }
	  }, {
	    key: 'handleBranchesLoaded',
	    value: function handleBranchesLoaded() {
	      var branches = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      this.mergeState({
	        branches: branches,
	        processing: false
	      });
	    }
	  }, {
	    key: 'handleEmployeeSearchValueChanged',
	    value: function handleEmployeeSearchValueChanged(employeeSearchValue) {
	      this.mergeState({
	        employeeSearchValue: employeeSearchValue
	      });
	    }
	  }, {
	    key: 'employeeErrorsReceived',
	    value: function employeeErrorsReceived() {
	      var employeeErrors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      this.mergeState({
	        employeeErrors: employeeErrors
	      });
	    }
	  }, {
	    key: 'getEmployees',
	    value: function getEmployees() {
	      var items = this.get('employees');
	
	      return items ? items.toJS() : [];
	    }
	  }, {
	    key: 'getBranches',
	    value: function getBranches() {
	      var items = this.get('branches');
	
	      return items ? items.toJS() : [];
	    }
	  }, {
	    key: 'getSelectedScreen',
	    value: function getSelectedScreen() {
	      return this.get('selectedScreen');
	    }
	  }, {
	    key: 'getEmployeeConflicts',
	    value: function getEmployeeConflicts() {
	      var items = this.get('employeeConflicts');
	      return items ? items.toJS() : [];
	    }
	  }, {
	    key: 'editEmployee',
	    value: function editEmployee(selectedEmployee) {
	      var newState = {
	        selectedScreen: 'edit',
	        selectedEmployee: selectedEmployee,
	        branches: [],
	        employeeErrors: [],
	        employeeConflicts: []
	      };
	
	      if (!selectedEmployee) {
	        newState.selectedEmployee = null;
	      }
	
	      this.mergeState(newState);
	    }
	  }, {
	    key: 'employeeEditCanceled',
	    value: function employeeEditCanceled() {
	      this.mergeState({
	        selectedScreen: 'login',
	        branches: [],
	        employeeErrors: [],
	        employeeConflicts: []
	      });
	    }
	  }, {
	    key: 'employeeSaved',
	    value: function employeeSaved(selectedEmployee) {
	      this.mergeState({
	        selectedEmployee: selectedEmployee,
	        selectedScreen: 'login',
	        branches: [],
	        employeeErrors: [],
	        processing: false,
	        employeeConflicts: []
	      });
	    }
	  }, {
	    key: 'employeeSelected',
	    value: function employeeSelected(selectedEmployee) {
	      var newState = {
	        selectedScreen: 'login',
	        selectedEmployee: selectedEmployee
	      };
	
	      this.mergeState(newState);
	    }
	  }, {
	    key: 'employeeDeselected',
	    value: function employeeDeselected() {
	      this.mergeState({
	        selectedScreen: 'search',
	        selectedEmployee: null,
	        employees: []
	      });
	    }
	  }, {
	    key: 'getEmployeeSearchValue',
	    value: function getEmployeeSearchValue() {
	      return this.get('employeeSearchValue');
	    }
	  }, {
	    key: 'getSelectedEmployee',
	    value: function getSelectedEmployee() {
	      var employee = this.get('selectedEmployee');
	
	      return employee ? employee.toJS() : null;
	    }
	  }, {
	    key: 'getEmployeeErrors',
	    value: function getEmployeeErrors() {
	      return this.get('employeeErrors').toJS();
	    }
	  }, {
	    key: 'isProcessing',
	    value: function isProcessing() {
	      return this.get('processing') || false;
	    }
	  }, {
	    key: 'canEdit',
	    value: function canEdit() {
	      return this.get('allowEdit');
	    }
	  }]);
	  return LoginStore;
	}(_fluxibleImmutableUtils.ImmutableStore), _class.storeName = 'LoginStore', _class.handlers = (_class$handlers = {}, (0, _defineProperty3.default)(_class$handlers, _Actions2.default.EMPLOYEES_LOADED, 'handleEmployeesLoaded'), (0, _defineProperty3.default)(_class$handlers, _Actions2.default.EMPLOYEES_CONFLICTS_LOADED, 'handleEmployeeConflictsLoaded'), (0, _defineProperty3.default)(_class$handlers, _Actions2.default.EMPLOYEE_SEARCH_VALUE_CHANGED, 'handleEmployeeSearchValueChanged'), (0, _defineProperty3.default)(_class$handlers, _Actions2.default.BRANCHES_LOADED, 'handleBranchesLoaded'), (0, _defineProperty3.default)(_class$handlers, _Actions2.default.NEW_EMPLOYEE_SELECTED, 'editEmployee'), (0, _defineProperty3.default)(_class$handlers, _Actions2.default.EDIT_EMPLOYEE_SELECTED, 'editEmployee'), (0, _defineProperty3.default)(_class$handlers, _Actions2.default.EMPLOYEE_SELECTED, 'employeeSelected'), (0, _defineProperty3.default)(_class$handlers, _Actions2.default.EMPLOYEE_DESELECTED, 'employeeDeselected'), (0, _defineProperty3.default)(_class$handlers, _Actions2.default.EMPLOYEE_UPDATE_SUCCESSFUL, 'employeeSaved'), (0, _defineProperty3.default)(_class$handlers, _Actions2.default.EMPLOYEE_UPDATE_CANCELED, 'employeeEditCanceled'), (0, _defineProperty3.default)(_class$handlers, _Actions2.default.EMPLOYEE_UPDATE_ERROR, 'employeeErrorsReceived'), (0, _defineProperty3.default)(_class$handlers, _Actions2.default.EMPLOYEE_SEARCH_STARTED, 'processingStarted'), (0, _defineProperty3.default)(_class$handlers, _Actions2.default.BRANCH_SEARCH_STARTED, 'processingStarted'), (0, _defineProperty3.default)(_class$handlers, _Actions2.default.EMPLOYEE_UPDATE_STARTED, 'processingStarted'), (0, _defineProperty3.default)(_class$handlers, _Actions2.default.EMPLOYEE_SEARCH_FAILED, 'processingCompleted'), (0, _defineProperty3.default)(_class$handlers, _Actions2.default.EMPLOYEE_UPDATE_FAILED, 'processingCompleted'), (0, _defineProperty3.default)(_class$handlers, _Actions2.default.EMPLOYEE_LOGIN_STARTED, 'processingStarted'), (0, _defineProperty3.default)(_class$handlers, _Actions2.default.EMPLOYEE_LOGGED_IN, 'processingCompleted'), (0, _defineProperty3.default)(_class$handlers, _Actions2.default.ENABLE_EDIT, 'handleEnableEdit'), _class$handlers), _temp);
	exports.default = LoginStore;
	module.exports = exports['default'];

/***/ },

/***/ 663:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(250);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(27);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(29);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(28);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp, _class$handlers; /**
	                                     * (c) 2015 Ignite Sales, Inc.
	                                     * User: aholmes
	                                     * Date: 6/8/2016
	                                     * Time: 9:28 AM
	                                     */
	
	
	var _fluxibleImmutableUtils = __webpack_require__(307);
	
	var _CommonActions = __webpack_require__(370);
	
	var _CommonActions2 = _interopRequireDefault(_CommonActions);
	
	var _Locale = __webpack_require__(118);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultState = {
	  messages: {},
	  locale: (0, _Locale.getLocale)()
	};
	
	var MessageStore = (_temp = _class = function (_ImmutableStore) {
	  (0, _inherits3.default)(MessageStore, _ImmutableStore);
	
	  function MessageStore(dispatcher) {
	    (0, _classCallCheck3.default)(this, MessageStore);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (MessageStore.__proto__ || (0, _getPrototypeOf2.default)(MessageStore)).call(this, dispatcher));
	
	    _this.setState(defaultState);
	    return _this;
	  }
	
	  (0, _createClass3.default)(MessageStore, [{
	    key: 'handleLocaleChanged',
	    value: function handleLocaleChanged(locale) {
	      this.mergeState({
	        locale: locale
	      });
	    }
	  }, {
	    key: 'handleMessagesLoaded',
	    value: function handleMessagesLoaded(messages) {
	      this.mergeState({
	        messages: messages
	      });
	    }
	  }, {
	    key: 'getMessages',
	    value: function getMessages() {
	      var messages = this.get(['messages', this.get('locale')]);
	
	      return messages ? messages.toJS() : {};
	    }
	  }, {
	    key: 'getLocale',
	    value: function getLocale() {
	      return this.get('locale');
	    }
	  }]);
	  return MessageStore;
	}(_fluxibleImmutableUtils.ImmutableStore), _class.storeName = 'MessageStore', _class.handlers = (_class$handlers = {}, (0, _defineProperty3.default)(_class$handlers, _CommonActions2.default.LOCALE_CHANGED, 'handleLocaleChanged'), (0, _defineProperty3.default)(_class$handlers, _CommonActions2.default.MESSAGES_LOADED, 'handleMessagesLoaded'), _class$handlers), _temp);
	exports.default = MessageStore;
	module.exports = exports['default'];

/***/ },

/***/ 670:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(27);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(29);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(28);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _fluxibleAddonsReact = __webpack_require__(61);
	
	var _Search = __webpack_require__(674);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _Edit = __webpack_require__(671);
	
	var _Edit2 = _interopRequireDefault(_Edit);
	
	var _Login = __webpack_require__(673);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _SearchActionCreators = __webpack_require__(122);
	
	var _reactIntl = __webpack_require__(10);
	
	var _reactFontawesome = __webpack_require__(31);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Container = (_dec = (0, _fluxibleAddonsReact.connectToStores)(['LoginStore', 'MessageStore'], function (context, props) {
	  var LoginStore = context.getStore('LoginStore');
	  var MessageStore = context.getStore('MessageStore');
	
	  return {
	    selectedScreen: LoginStore.getSelectedScreen(),
	    messages: MessageStore.getMessages(),
	    locale: MessageStore.getLocale(),
	    canEdit: LoginStore.canEdit()
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(Container, _Component);
	
	  function Container(props) {
	    (0, _classCallCheck3.default)(this, Container);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Container.__proto__ || (0, _getPrototypeOf2.default)(Container)).call(this, props));
	
	    _this.backClicked = _this.backClicked.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(Container, [{
	    key: 'backClicked',
	    value: function backClicked() {
	      this.context.executeAction(_SearchActionCreators.backToSearchClicked, {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          selectedScreen = _props.selectedScreen,
	          messages = _props.messages,
	          locale = _props.locale,
	          canEdit = _props.canEdit;
	
	
	      var FrameComponent = _Search2.default;
	      var backButton = _react2.default.createElement(
	        'button',
	        { className: 'btn btn-link back', onClick: this.backClicked },
	        _react2.default.createElement(_reactFontawesome2.default, { name: 'arrow-left' })
	      );
	      var back = void 0;
	
	      switch (selectedScreen) {
	        case 'edit':
	          FrameComponent = _Edit2.default;
	          back = backButton;
	          break;
	        case 'login':
	          FrameComponent = _Login2.default;
	          back = backButton;
	          break;
	        default:
	          break;
	      }
	
	      if (!canEdit) {
	        back = undefined;
	      }
	
	      return _react2.default.createElement(
	        _reactIntl.IntlProvider,
	        { locale: locale, messages: messages },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-container employee-login-container' },
	          back,
	          _react2.default.createElement(FrameComponent, null)
	        )
	      );
	    }
	  }]);
	  return Container;
	}(_react.Component), _class2.propTypes = {
	  selectedScreen: _propTypes2.default.string.isRequired,
	  messages: _propTypes2.default.object.isRequired,
	  locale: _propTypes2.default.string.isRequired,
	  canEdit: _propTypes2.default.bool.isRequired
	}, _class2.contextTypes = {
	  executeAction: _propTypes2.default.func.isRequired
	}, _temp)) || _class);
	exports.default = Container;
	module.exports = exports['default'];

/***/ },

/***/ 671:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(247);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _extends2 = __webpack_require__(54);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(27);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(29);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(28);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _fluxibleAddonsReact = __webpack_require__(61);
	
	var _SearchActionCreators = __webpack_require__(122);
	
	var _reactFormControlled = __webpack_require__(86);
	
	var _reactFormControlled2 = _interopRequireDefault(_reactFormControlled);
	
	var _reactFormControlledValidate = __webpack_require__(140);
	
	var _reactFormControlledValidate2 = _interopRequireDefault(_reactFormControlledValidate);
	
	var _Shapes = __webpack_require__(81);
	
	var _MessageDefinitions = __webpack_require__(145);
	
	var _MessageDefinitions2 = _interopRequireDefault(_MessageDefinitions);
	
	var _reactIntl = __webpack_require__(10);
	
	var _libphonenumber = __webpack_require__(212);
	
	var _BranchResult = __webpack_require__(374);
	
	var _BranchResult2 = _interopRequireDefault(_BranchResult);
	
	var _lodash = __webpack_require__(214);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactFontawesome = __webpack_require__(31);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _lodash3 = __webpack_require__(1023);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	var _FormError = __webpack_require__(371);
	
	var _FormError2 = _interopRequireDefault(_FormError);
	
	var _FormInput = __webpack_require__(144);
	
	var _EmployeeResult = __webpack_require__(242);
	
	var _EmployeeResult2 = _interopRequireDefault(_EmployeeResult);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formSchema = {
	  type: 'object',
	  properties: {
	    firstName: {
	      type: 'string',
	      minLength: 1
	    },
	    lastName: {
	      type: 'string',
	      minLength: 1
	    },
	    email: {
	      type: 'string',
	      format: 'email'
	    },
	    phone: {
	      type: 'string',
	      'pattern': '^\\([0-9]{3}\\)\\s*[0-9]{3}-[0-9]{4}$|^[0-9]{10}$'
	    },
	    nmlsId: {
	      type: 'string',
	      'pattern': '^[0-9]{0,12}$'
	    }
	  },
	  'required': ['firstName', 'lastName', 'email', 'phone']
	};
	
	var requireEmployeeId = !window.ignite.ignoreEmployeeId;
	
	if (requireEmployeeId) {
	  formSchema.required.push('employeeId');
	  if (window.ignite.validations && window.ignite.validations.employeeLogin) {
	    (0, _lodash4.default)(formSchema.properties, window.ignite.validations.employeeLogin);
	  }
	}
	
	var requireNmlsId = window.ignite.validations && window.ignite.validations.requireEmployeeNmlsId;
	if (requireNmlsId) {
	  formSchema.required.push('nmlsId');
	}
	
	function branchesContains(branches, item) {
	  return branches.find(function (branch) {
	    return branch.id === item.id;
	  });
	}
	
	var Edit = (_dec = (0, _fluxibleAddonsReact.connectToStores)(['LoginStore'], function (context, props) {
	  var LoginStore = context.getStore('LoginStore');
	
	  return {
	    employee: LoginStore.getSelectedEmployee(),
	    foundBranches: LoginStore.getBranches(),
	    formErrors: LoginStore.getEmployeeErrors(),
	    processing: LoginStore.isProcessing(),
	    allowEdit: LoginStore.canEdit(),
	    employeeConflicts: LoginStore.getEmployeeConflicts()
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(Edit, _Component);
	
	  function Edit(props) {
	    (0, _classCallCheck3.default)(this, Edit);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Edit.__proto__ || (0, _getPrototypeOf2.default)(Edit)).call(this, props));
	
	    _this.formValueChanged = function (state) {
	      state.phone = state.phone.replace(/\D/g, '');
	      _this.form.validate(state).then(function () {
	        var formErrors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	        _this.context.executeAction(_SearchActionCreators.employeeValidationError, formErrors);
	      });
	
	      if (state.email !== _this.state.form.email || state.employeeId !== _this.state.form.employeeId) {
	        _this.searchForEmployeeConflict();
	      }
	
	      _this.setState((0, _extends3.default)({}, _this.state, {
	        form: state
	      }));
	    };
	
	    _this.branchSearchValueChanged = function (event) {
	      _this.searchValue = event.target.value;
	      _this.loadBranches(_this.searchValue);
	    };
	
	    _this.formSubmitted = function (state) {
	      state.phone = state.phone.replace(/\D/g, '');
	      var employee = state;
	      employee.id = _this.props.employee ? _this.props.employee.id : null;
	      employee.branches = _this.state.branches;
	      _this.context.executeAction(_SearchActionCreators.saveEmployeeProfile, {
	        employee: employee
	      });
	    };
	
	    _this.cancelClicked = function (event) {
	      event.preventDefault();
	      _this.context.executeAction(_SearchActionCreators.employeeCancelClicked, {});
	    };
	
	    var _ref = _this.props.employee || {},
	        id = _ref.id,
	        employeeId = _ref.employeeId,
	        firstName = _ref.firstName,
	        lastName = _ref.lastName,
	        email = _ref.email,
	        phone = _ref.phone,
	        _ref$branches = _ref.branches,
	        branches = _ref$branches === undefined ? [] : _ref$branches,
	        nmlsId = _ref.nmlsId;
	
	    _this.state = {
	      branches: branches,
	      form: {
	        firstName: firstName,
	        lastName: lastName,
	        email: email,
	        phone: phone,
	        employeeId: employeeId,
	        nmlsId: nmlsId,
	        searchValue: ''
	      }
	    };
	    _this.searchValue = '';
	    _this.loadBranches = (0, _lodash2.default)(function (searchValue) {
	      _this.context.executeAction(_SearchActionCreators.loadBranches, {
	        searchValue: searchValue
	      });
	    }, 500, {
	      maxWait: 1000
	    });
	    _this.searchForEmployeeConflict = (0, _lodash2.default)(function () {
	      _this.context.executeAction(_SearchActionCreators.searchEmployeeConflicts, {
	        searchByEmail: _this.state.form.email,
	        searchById: _this.state.form.employeeId
	      });
	    }, 500);
	    return _this;
	  }
	
	  (0, _createClass3.default)(Edit, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.form.validate(this.state.form, function (_) {
	        var formErrors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	        _this2.context.executeAction(_SearchActionCreators.employeeValidationError, formErrors);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var formatMessage = this.context.intl.formatMessage;
	      var _state = this.state,
	          _state$branches = _state.branches,
	          branches = _state$branches === undefined ? [] : _state$branches,
	          _state$form = _state.form,
	          form = _state$form === undefined ? {} : _state$form;
	
	      var value = (0, _extends3.default)({}, form);
	
	      var _props = this.props,
	          _props$foundBranches = _props.foundBranches,
	          foundBranches = _props$foundBranches === undefined ? [] : _props$foundBranches,
	          _props$formErrors = _props.formErrors,
	          formErrors = _props$formErrors === undefined ? [] : _props$formErrors,
	          processing = _props.processing,
	          allowEdit = _props.allowEdit,
	          _props$employeeConfli = _props.employeeConflicts,
	          employeeConflicts = _props$employeeConfli === undefined ? [] : _props$employeeConfli;
	
	
	      var cancelButton = this.props.employee ? _react2.default.createElement(
	        'button',
	        { onClick: this.cancelClicked, className: 'btn btn-cancel cancel', disabled: branches.length === 0 },
	        _react2.default.createElement(_reactIntl.FormattedMessage, _MessageDefinitions2.default.cancel)
	      ) : null;
	
	      var conflictResults = employeeConflicts.map(function (item) {
	        var employeeClicked = function employeeClicked() {
	          _this3.context.executeAction(_SearchActionCreators.selectEmployee, item);
	        };
	        return _react2.default.createElement(
	          'div',
	          { className: 'employee-login-result', onClick: employeeClicked, key: item.id },
	          _react2.default.createElement(
	            'div',
	            { className: 'name' },
	            _react2.default.createElement(
	              'span',
	              { className: 'firstName' },
	              item.firstName
	            ),
	            ' ',
	            _react2.default.createElement(
	              'span',
	              { className: 'lastName' },
	              item.lastName
	            )
	          )
	        );
	      });
	
	      var conflictMessage = conflictResults && conflictResults.length > 0 ? _react2.default.createElement(
	        'div',
	        { className: 'text-center' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, _MessageDefinitions2.default.profileConflicts)
	      ) : null;
	
	      var branchResults = foundBranches.map(function (branch) {
	        var addBranch = function addBranch() {
	          if (!branchesContains(branches, branch)) {
	            branches.push(branch);
	            _this3.setState((0, _extends3.default)({}, _this3.state, {
	              branches: branches
	            }));
	          }
	        };
	
	        return _react2.default.createElement(
	          _BranchResult2.default,
	          { key: branch.id, onClick: addBranch, branch: branch },
	          _react2.default.createElement(_reactFontawesome2.default, { name: 'plus-circle' })
	        );
	      });
	
	      var employeeBranches = branches.map(function (branch) {
	        var removeBranch = function removeBranch() {
	          var newBranches = branches.filter(function (b) {
	            return branch.id !== b.id;
	          });
	          _this3.setState((0, _extends3.default)({}, _this3.state, {
	            branches: newBranches
	          }));
	        };
	
	        return _react2.default.createElement(
	          _BranchResult2.default,
	          { key: branch.id, onClick: removeBranch, branch: branch },
	          _react2.default.createElement(_reactFontawesome2.default, { name: 'minus-circle' })
	        );
	      });
	
	      var errorMessages = {};
	      var fieldErrors = {};
	      var fields = {};
	
	      if (employeeBranches.length === 0) {
	        errorMessages.employeeBranches = _react2.default.createElement(_FormError2.default, { message: _MessageDefinitions2.default.employeeBranchesError });
	      }
	      formErrors.forEach(function (error) {
	        fieldErrors[error.key] = true;
	      });
	
	      ['firstName', 'lastName', 'employeeId', 'email', 'phone', 'nmlsId'].forEach(function (key) {
	        var errorMessage = _MessageDefinitions2.default[key + 'Error'];
	        var hasError = fieldErrors[key];
	        if (key === 'email' && employeeConflicts.find(function (e) {
	          return e.email === value.email;
	        })) {
	          hasError = true;
	          errorMessage = _MessageDefinitions2.default.emailConflicts;
	        } else if (key === 'employeeId' && employeeConflicts.find(function (e) {
	          return e.employeeId === value.employeeId;
	        })) {
	          hasError = true;
	          errorMessage = _MessageDefinitions2.default.employeeIdConflicts;
	        }
	        fields[key] = (0, _FormInput.textInput)({
	          type: 'text',
	          name: key,
	          labelMessage: _MessageDefinitions2.default[key],
	          placeholderMessage: _MessageDefinitions2.default[key + 'Placeholder'],
	          errorMessage: errorMessage,
	          hasError: hasError,
	          formatMessage: formatMessage,
	          disabled: !allowEdit
	        });
	      });
	
	      var formValid = formErrors.length === 0 && employeeBranches.length > 0;
	      var formatter = new _libphonenumber.AsYouTypeFormatter('US');
	      var phoneNumber = '';
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(value.phone || []), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var n = _step.value;
	
	          phoneNumber = formatter.inputDigit(n);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      value.phone = phoneNumber;
	      value.searchValue = this.searchValue;
	
	      var buttonMessage = processing ? _react2.default.createElement(_reactFontawesome2.default, { name: 'refresh', spin: true }) : _react2.default.createElement(_reactIntl.FormattedMessage, _MessageDefinitions2.default.save);
	
	      var employeeIdSection = requireEmployeeId ? fields.employeeId : null;
	      var nmlsIdSection = requireNmlsId ? fields.nmlsId : null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'employee-login-edit' },
	        _react2.default.createElement(
	          _reactFormControlledValidate2.default,
	          { schema: formSchema, ref: function ref(f) {
	              return _this3.form = f;
	            } },
	          _react2.default.createElement(
	            _reactFormControlled2.default,
	            { value: value,
	              onChange: this.formValueChanged,
	              onSubmit: this.formSubmitted },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-body' },
	              fields.firstName,
	              fields.lastName,
	              employeeIdSection,
	              nmlsIdSection,
	              fields.email,
	              fields.phone,
	              _react2.default.createElement(
	                'div',
	                { className: 'form-group branch-search' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-label' },
	                  _react2.default.createElement(_reactIntl.FormattedMessage, _MessageDefinitions2.default.branchesSearch)
	                ),
	                _react2.default.createElement('input', { type: 'text',
	                  className: 'form-control',
	                  name: 'searchValue',
	                  placeholder: formatMessage(_MessageDefinitions2.default.branchesSearchPlaceholder),
	                  onChange: this.branchSearchValueChanged })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-group branch-result' },
	                branchResults
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-group employee-branches' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-label' },
	                  _react2.default.createElement(_reactIntl.FormattedMessage, _MessageDefinitions2.default.branchesAssociated)
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-control' },
	                  employeeBranches
	                ),
	                errorMessages.employeeBranches
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              conflictMessage,
	              conflictResults
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-actions' },
	              cancelButton,
	              _react2.default.createElement(
	                'button',
	                { type: 'submit', className: 'btn btn-primary save', disabled: !formValid || processing || conflictResults && conflictResults.length > 0 },
	                buttonMessage
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return Edit;
	}(_react.Component), _class2.propTypes = {
	  employee: _Shapes.EmployeeShape,
	  foundBranches: _propTypes2.default.arrayOf(_Shapes.BranchShape),
	  formErrors: _propTypes2.default.arrayOf(_Shapes.FormErrorShape),
	  processing: _propTypes2.default.bool.isRequired,
	  employeeConflicts: _propTypes2.default.array
	}, _class2.contextTypes = {
	  executeAction: _propTypes2.default.func.isRequired,
	  intl: _reactIntl.intlShape
	}, _temp)) || _class);
	exports.default = Edit;
	module.exports = exports['default'];

/***/ },

/***/ 672:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(27);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(29);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(28);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _EmployeeResult = __webpack_require__(242);
	
	var _EmployeeResult2 = _interopRequireDefault(_EmployeeResult);
	
	var _fluxibleAddonsReact = __webpack_require__(61);
	
	var _SearchActionCreators = __webpack_require__(122);
	
	var _MessageDefinitions = __webpack_require__(145);
	
	var _MessageDefinitions2 = _interopRequireDefault(_MessageDefinitions);
	
	var _reactIntl = __webpack_require__(10);
	
	var _reactFontawesome = __webpack_require__(31);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Results = (_dec = (0, _fluxibleAddonsReact.connectToStores)(['LoginStore'], function (context, props) {
	  var LoginStore = context.getStore('LoginStore');
	
	  return {
	    employees: LoginStore.getEmployees()
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(Results, _Component);
	
	  function Results(props) {
	    (0, _classCallCheck3.default)(this, Results);
	    return (0, _possibleConstructorReturn3.default)(this, (Results.__proto__ || (0, _getPrototypeOf2.default)(Results)).call(this, props));
	  }
	
	  (0, _createClass3.default)(Results, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          employees = _props.employees,
	          completedSearch = _props.completedSearch;
	
	
	      var searchResults = employees.map(function (item) {
	        var employeeClicked = function employeeClicked() {
	          _this2.context.executeAction(_SearchActionCreators.selectEmployee, item);
	        };
	
	        return _react2.default.createElement(_EmployeeResult2.default, { key: item.id, employee: item, onClick: employeeClicked });
	      });
	
	      var component = null;
	
	      if (completedSearch && !searchResults.length) {
	        component = _react2.default.createElement(
	          'div',
	          { className: 'employee-login-result empty' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, _MessageDefinitions2.default.noProfiles)
	        );
	      } else if (searchResults.length > 0) {
	        component = _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'text-center' },
	            'Click on a profile to login.'
	          ),
	          searchResults
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'employee-login-results' },
	        component
	      );
	    }
	  }]);
	  return Results;
	}(_react.Component), _class2.propTypes = {
	  employees: _propTypes2.default.array,
	  completedSearch: _propTypes2.default.bool
	}, _class2.contextTypes = {
	  executeAction: _propTypes2.default.func.isRequired
	}, _temp)) || _class);
	exports.default = Results;
	module.exports = exports['default'];

/***/ },

/***/ 673:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(27);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(29);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(28);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _fluxibleAddonsReact = __webpack_require__(61);
	
	var _SearchActionCreators = __webpack_require__(122);
	
	var _EmployeeResult = __webpack_require__(242);
	
	var _EmployeeResult2 = _interopRequireDefault(_EmployeeResult);
	
	var _BranchResult = __webpack_require__(374);
	
	var _BranchResult2 = _interopRequireDefault(_BranchResult);
	
	var _reactFontawesome = __webpack_require__(31);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _reactIntl = __webpack_require__(10);
	
	var _MessageDefinitions = __webpack_require__(145);
	
	var _MessageDefinitions2 = _interopRequireDefault(_MessageDefinitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Results = (_dec = (0, _fluxibleAddonsReact.connectToStores)(['LoginStore'], function (context, props) {
	  var LoginStore = context.getStore('LoginStore');
	
	  return {
	    employee: LoginStore.getSelectedEmployee(),
	    processing: LoginStore.isProcessing()
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(Results, _Component);
	
	  function Results(props) {
	    (0, _classCallCheck3.default)(this, Results);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Results.__proto__ || (0, _getPrototypeOf2.default)(Results)).call(this, props));
	
	    _this.loginClicked = _this.loginClicked.bind(_this);
	    _this.editClicked = _this.editClicked.bind(_this);
	
	    var state = {};
	    if (props.employee && props.employee.branches && props.employee.branches.length === 1) {
	      state.selectedBranch = props.employee.branches[0];
	    }
	
	    _this.state = state;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Results, [{
	    key: 'loginClicked',
	    value: function loginClicked() {
	      this.context.executeAction(_SearchActionCreators.login, {
	        employee: this.props.employee,
	        branch: this.state.selectedBranch
	      });
	    }
	  }, {
	    key: 'editClicked',
	    value: function editClicked() {
	      this.context.executeAction(_SearchActionCreators.editEmployee, this.props.employee);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          employee = _props.employee,
	          processing = _props.processing;
	      var selectedBranch = this.state.selectedBranch;
	
	
	      var loginDisabled = selectedBranch ? false : true;
	
	      var selectedBranchMessage = selectedBranch ? null : _react2.default.createElement(_reactIntl.FormattedMessage, _MessageDefinitions2.default.branchesSelect);
	
	      var branchComponents = (employee.branches || []).map(function (branch) {
	        var branchClicked = function branchClicked() {
	          _this2.setState({
	            selectedBranch: branch
	          });
	        };
	
	        var selected = selectedBranch && selectedBranch.id === branch.id;
	
	        var className = selected ? 'selected' : '';
	
	        var children = selected ? _react2.default.createElement(_reactFontawesome2.default, { name: 'check' }) : null;
	
	        return _react2.default.createElement(
	          _BranchResult2.default,
	          { key: branch.id, className: className, onClick: branchClicked, branch: branch },
	          children
	        );
	      });
	
	      var buttonMessage = processing ? _react2.default.createElement(_reactFontawesome2.default, { name: 'refresh', spin: true }) : _react2.default.createElement(_reactIntl.FormattedMessage, _MessageDefinitions2.default.login);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'employee-login-selected' },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-body' },
	          _react2.default.createElement(_EmployeeResult2.default, { employee: employee }),
	          _react2.default.createElement(
	            'div',
	            { className: 'branch-list' },
	            branchComponents
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'branch-select-message' },
	            selectedBranchMessage
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-actions' },
	          _react2.default.createElement(
	            'button',
	            { onClick: this.editClicked, className: 'btn btn-primary edit', disabled: processing },
	            _react2.default.createElement(_reactIntl.FormattedMessage, _MessageDefinitions2.default.edit)
	          ),
	          _react2.default.createElement(
	            'button',
	            { onClick: this.loginClicked, className: 'btn btn-primary login', disabled: loginDisabled || processing },
	            buttonMessage
	          )
	        )
	      );
	    }
	  }]);
	  return Results;
	}(_react.Component), _class2.propTypes = {
	  employee: _propTypes2.default.object.isRequired,
	  processing: _propTypes2.default.bool.isRequired
	}, _class2.contextTypes = {
	  executeAction: _propTypes2.default.func.isRequired
	}, _temp)) || _class);
	exports.default = Results;
	module.exports = exports['default'];

/***/ },

/***/ 674:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(54);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(27);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(29);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(28);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SearchActionCreators = __webpack_require__(122);
	
	var _fluxibleAddonsReact = __webpack_require__(61);
	
	var _EmployeeResults = __webpack_require__(672);
	
	var _EmployeeResults2 = _interopRequireDefault(_EmployeeResults);
	
	var _lodash = __webpack_require__(214);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactFontawesome = __webpack_require__(31);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _reactIntl = __webpack_require__(10);
	
	var _MessageDefinitions = __webpack_require__(145);
	
	var _MessageDefinitions2 = _interopRequireDefault(_MessageDefinitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Search = (_dec = (0, _fluxibleAddonsReact.connectToStores)(['LoginStore'], function (context, props) {
	  var LoginStore = context.getStore('LoginStore');
	
	  return {
	    initialSearchValue: LoginStore.getEmployeeSearchValue(),
	    processing: LoginStore.isProcessing(),
	    employees: LoginStore.getEmployees()
	  };
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(Search, _Component);
	
	  function Search(props) {
	    (0, _classCallCheck3.default)(this, Search);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Search.__proto__ || (0, _getPrototypeOf2.default)(Search)).call(this, props));
	
	    _this.state = {
	      searchValue: _this.props.initialSearchValue,
	      initiatedSearch: false
	    };
	    _this.searchValueChanged = _this.searchValueChanged.bind(_this);
	    _this.newProfileClicked = _this.newProfileClicked.bind(_this);
	    _this.loadEmployees = (0, _lodash2.default)(function (searchValue) {
	      _this.context.executeAction(_SearchActionCreators.loadEmployees, {
	        searchValue: searchValue
	      });
	      _this.setState((0, _extends3.default)({}, _this.state, {
	        initiatedSearch: true
	      }));
	    }, 500);
	    return _this;
	  }
	
	  (0, _createClass3.default)(Search, [{
	    key: 'searchValueChanged',
	    value: function searchValueChanged(event) {
	      var searchValue = event.target.value || '';
	      this.setState((0, _extends3.default)({}, this.state, {
	        searchValue: searchValue,
	        initiatedSearch: this.props.processing
	      }));
	      this.loadEmployees(searchValue);
	    }
	  }, {
	    key: 'newProfileClicked',
	    value: function newProfileClicked() {
	      this.context.executeAction(_SearchActionCreators.newEmployee, {});
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          searchValue = _state.searchValue,
	          initiatedSearch = _state.initiatedSearch;
	      var intl = this.context.intl;
	      var _props$employees = this.props.employees,
	          employees = _props$employees === undefined ? [] : _props$employees;
	
	
	      var searchSpinner = this.props.processing ? _react2.default.createElement(
	        'div',
	        { className: 'search-loading' },
	        _react2.default.createElement(_reactFontawesome2.default, { name: 'refresh', spin: true })
	      ) : null;
	
	      var completedSearch = initiatedSearch && !this.props.processing;
	
	      var newProfileButton = !this.props.processing ? _react2.default.createElement(
	        'div',
	        { className: 'newProfile' },
	        _react2.default.createElement(
	          'div',
	          { className: 'text-center' },
	          'OR'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'text-center mb-3 m-b-1' },
	          'If you have not used this application before, click "',
	          _react2.default.createElement(_reactIntl.FormattedMessage, _MessageDefinitions2.default.newProfile),
	          '" below to create a profile.'
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-secondary', onClick: this.newProfileClicked },
	          _react2.default.createElement(_reactIntl.FormattedMessage, _MessageDefinitions2.default.newProfile),
	          ' ',
	          _react2.default.createElement(_reactFontawesome2.default, { name: 'plus-circle' })
	        )
	      ) : null;
	
	      var employeeResults = searchValue ? _react2.default.createElement(_EmployeeResults2.default, { completedSearch: completedSearch }) : null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'employee-login-search' },
	        _react2.default.createElement(
	          'div',
	          { className: 'form-body' },
	          _react2.default.createElement(
	            'div',
	            { className: 'form-group search-form' },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'employeeLoginSearchBox', className: 'search-label form-label' },
	              'Find your profile'
	            ),
	            _react2.default.createElement('input', { type: 'search',
	              id: 'employeeLoginSearchBox',
	              className: 'form-control search-box',
	              placeholder: intl.formatMessage(_MessageDefinitions2.default.findProfilePlaceholder),
	              value: searchValue,
	              onChange: this.searchValueChanged }),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'em',
	                null,
	                _react2.default.createElement(_reactIntl.FormattedMessage, _MessageDefinitions2.default.searchText)
	              )
	            )
	          ),
	          employeeResults,
	          newProfileButton,
	          searchSpinner
	        )
	      );
	    }
	  }]);
	  return Search;
	}(_react.Component), _class2.propTypes = {
	  initialSearchValue: _propTypes2.default.string.isRequired,
	  processing: _propTypes2.default.bool.isRequired,
	  employees: _propTypes2.default.array
	}, _class2.contextTypes = {
	  executeAction: _propTypes2.default.func.isRequired,
	  intl: _reactIntl.intlShape
	}, _temp)) || _class);
	exports.default = Search;
	module.exports = exports['default'];

/***/ },

/***/ 1019:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module, global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/** Used to determine if values are of the language type `Object`. */
	var objectTypes = {
	  'function': true,
	  'object': true
	};
	
	/** Detect free variable `exports`. */
	var freeExports = (objectTypes[typeof exports] && exports && !exports.nodeType)
	  ? exports
	  : undefined;
	
	/** Detect free variable `module`. */
	var freeModule = (objectTypes[typeof module] && module && !module.nodeType)
	  ? module
	  : undefined;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = (freeModule && freeModule.exports === freeExports)
	  ? freeExports
	  : undefined;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = checkGlobal(freeExports && freeModule && typeof global == 'object' && global);
	
	/** Detect free variable `self`. */
	var freeSelf = checkGlobal(objectTypes[typeof self] && self);
	
	/** Detect free variable `window`. */
	var freeWindow = checkGlobal(objectTypes[typeof window] && window);
	
	/** Detect `this` as the global object. */
	var thisGlobal = checkGlobal(objectTypes[typeof this] && this);
	
	/**
	 * Used as a reference to the global object.
	 *
	 * The `this` value is used if it's the global object to avoid Greasemonkey's
	 * restricted `window` object, otherwise the `window` object is used.
	 */
	var root = freeGlobal ||
	  ((freeWindow !== (thisGlobal && thisGlobal.window)) && freeWindow) ||
	    freeSelf || thisGlobal || Function('return this')();
	
	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `Map#set` because it doesn't return the map instance in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  set.add(value);
	  return set;
	}
	
	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is a global object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {null|Object} Returns `value` if it's a global object, else `null`.
	 */
	function checkGlobal(value) {
	  return (value && value.Object === Object) ? value : null;
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    getOwnPropertySymbols = Object.getOwnPropertySymbols,
	    objectCreate = Object.create,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetPrototype = Object.getPrototypeOf,
	    nativeKeys = Object.keys;
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache && cache.__data__.length == LARGE_ARRAY_SIZE) {
	    cache = this.__data__ = new MapCache(cache.__data__);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @param {boolean} [isFull] Specify a clone including symbols.
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
	  var result;
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      if (isHostObject(value)) {
	        return object ? value : {};
	      }
	      result = initCloneObject(isFunc ? {} : value);
	      if (!isDeep) {
	        return copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (!isArr) {
	    var props = isFull ? getAllKeys(value) : keys(value);
	  }
	  // Recursively populate clone (susceptible to call stack limits).
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
	  });
	  return result;
	}
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} prototype The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	function baseCreate(proto) {
	  return isObject(proto) ? objectCreate(proto) : {};
	}
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	/**
	 * The base implementation of `_.has` without support for deep paths.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHas(object, key) {
	  // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
	  // that are composed entirely of index properties, return `false` for
	  // `hasOwnProperty` checks of them.
	  return hasOwnProperty.call(object, key) ||
	    (typeof object == 'object' && key in object && getPrototype(object) === null);
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't skip the constructor
	 * property of prototypes or treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  return nativeKeys(Object(object));
	}
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var result = new buffer.constructor(buffer.length);
	  buffer.copy(result);
	  return result;
	}
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : source[key];
	
	    assignValue(object, key, newValue);
	  }
	  return object;
	}
	
	/**
	 * Copies own symbol properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a
	 * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
	 * Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Gets the `[[Prototype]]` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {null|Object} Returns the `[[Prototype]]`.
	 */
	function getPrototype(value) {
	  return nativeGetPrototype(Object(value));
	}
	
	/**
	 * Creates an array of the own enumerable symbol properties of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	function getSymbols(object) {
	  // Coerce `object` to an object to avoid non-object errors in V8.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=3443 for more details.
	  return getOwnPropertySymbols(Object(object));
	}
	
	// Fallback for IE < 11.
	if (!getOwnPropertySymbols) {
	  getSymbols = function() {
	    return [];
	  };
	}
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function getTag(value) {
	  return objectToString.call(value);
	}
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	/**
	 * Creates an array of index keys for `object` values of arrays,
	 * `arguments` objects, and strings, otherwise `null` is returned.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array|null} Returns index keys, else `null`.
	 */
	function indexKeys(object) {
	  var length = object ? object.length : undefined;
	  if (isLength(length) &&
	      (isArray(object) || isString(object) || isArguments(object))) {
	    return baseTimes(length, String);
	  }
	  return null;
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 * var other = { 'user': 'fred' };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @type {Function}
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value)) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = !Buffer ? constant(false) : function(value) {
	  return value instanceof Buffer;
	};
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8 which returns 'object' for typed array and weak map constructors,
	  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length,
	 *  else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  var isProto = isPrototype(object);
	  if (!(isProto || isArrayLike(object))) {
	    return baseKeys(object);
	  }
	  var indexes = indexKeys(object),
	      skipIndexes = !!indexes,
	      result = indexes || [],
	      length = result.length;
	
	  for (var key in object) {
	    if (baseHas(object, key) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length))) &&
	        !(isProto && key == 'constructor')) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 * var getter = _.constant(object);
	 *
	 * getter() === object;
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = baseClone;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(95)(module), (function() { return this; }())))

/***/ },

/***/ 1020:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module, global) {/**
	 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** Used to determine if values are of the language type `Object`. */
	var objectTypes = {
	  'function': true,
	  'object': true
	};
	
	/** Detect free variable `exports`. */
	var freeExports = (objectTypes[typeof exports] && exports && !exports.nodeType)
	  ? exports
	  : undefined;
	
	/** Detect free variable `module`. */
	var freeModule = (objectTypes[typeof module] && module && !module.nodeType)
	  ? module
	  : undefined;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = checkGlobal(freeExports && freeModule && typeof global == 'object' && global);
	
	/** Detect free variable `self`. */
	var freeSelf = checkGlobal(objectTypes[typeof self] && self);
	
	/** Detect free variable `window`. */
	var freeWindow = checkGlobal(objectTypes[typeof window] && window);
	
	/** Detect `this` as the global object. */
	var thisGlobal = checkGlobal(objectTypes[typeof this] && this);
	
	/**
	 * Used as a reference to the global object.
	 *
	 * The `this` value is used if it's the global object to avoid Greasemonkey's
	 * restricted `window` object, otherwise the `window` object is used.
	 */
	var root = freeGlobal ||
	  ((freeWindow !== (thisGlobal && thisGlobal.window)) && freeWindow) ||
	    freeSelf || thisGlobal || Function('return this')();
	
	/**
	 * Checks if `value` is a global object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {null|Object} Returns `value` if it's a global object, else `null`.
	 */
	function checkGlobal(value) {
	  return (value && value.Object === Object) ? value : null;
	}
	
	module.exports = root;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(95)(module), (function() { return this; }())))

/***/ },

/***/ 1021:
/***/ function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) ||
	      objectToString.call(value) != objectTag || isHostObject(value)) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return (typeof Ctor == 'function' &&
	    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	}
	
	module.exports = isPlainObject;


/***/ },

/***/ 1022:
/***/ function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ },

/***/ 1023:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	var baseClone = __webpack_require__(1019),
	    isPlainObject = __webpack_require__(1021),
	    keysIn = __webpack_require__(1022),
	    rest = __webpack_require__(1024),
	    root = __webpack_require__(1020);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache && cache.__data__.length == LARGE_ARRAY_SIZE) {
	    cache = this.__data__ = new MapCache(cache.__data__);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (typeof key == 'number' && value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  if (!(isArray(source) || isTypedArray(source))) {
	    var props = keysIn(source);
	  }
	  arrayEach(props || source, function(srcValue, key) {
	    if (props) {
	      key = srcValue;
	      srcValue = source[key];
	    }
	    if (isObject(srcValue)) {
	      stack || (stack = new Stack);
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  });
	}
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = object[key],
	      srcValue = source[key],
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    newValue = srcValue;
	    if (isArray(srcValue) || isTypedArray(srcValue)) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else {
	        isCommon = false;
	        newValue = baseClone(srcValue, true);
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	        isCommon = false;
	        newValue = baseClone(srcValue, true);
	      }
	      else {
	        newValue = objValue;
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  stack.set(srcValue, newValue);
	
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	  }
	  stack['delete'](srcValue);
	  assignMergeValue(object, key, newValue);
	}
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : source[key];
	
	    assignValue(object, key, newValue);
	  }
	  return object;
	}
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return rest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a
	 * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
	 * Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 * var other = { 'user': 'fred' };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @type {Function}
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value)) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8 which returns 'object' for typed array and weak map constructors,
	  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length,
	 *  else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	function isTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var users = {
	 *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	 * };
	 *
	 * var ages = {
	 *   'data': [{ 'age': 36 }, { 'age': 40 }]
	 * };
	 *
	 * _.merge(users, ages);
	 * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ },

/***/ 1024:
/***/ function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308,
	    NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as
	 * an array.
	 *
	 * **Note:** This method is based on the
	 * [rest parameter](https://mdn.io/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.rest(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function rest(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = start === undefined ? start : toInteger(start);
	  return baseRest(func, start);
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = rest;


/***/ }

});


/** WEBPACK FOOTER **
 ** employee-login.min.js
 **/